import { Component, OnInit } from '@angular/core';
export interface Location {
  value: string;
  viewValue: string;
}

export interface Helmet {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
 

  ngOnInit() {
  //   this.optionsSelect = [
  //     { value: '1', label: 'Option 1' },
  //     { value: '2', label: 'Option 2' },
  //     { value: '3', label: 'Option 3' },
  // ];
  }
  selectedValue:string;
  locations: Location[] = [
    {value: '4th Floor Salarpuria Towers -1 22, Hosur Road, Koramangala, Bangalore Karnataka', viewValue: 'Kormangla'},
    {value: 'indiranagar', viewValue: 'Indira Nagar'},
     ];

     helmets: Helmet[] = [
      {value: 'yes', viewValue: 'Yes'},
      {value: 'no', viewValue: 'No'},
       ];  
  constructor() { }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/about/about.component.ts